import tools from "../../../../assets/javascript/tools.js";
export default {
    columns: {
        staffName: {
            label: "姓名",
            visible: true,
            width: "120",
            align: "left",
        },
        oxCtime: {
            label: "申请时间",
            visible: true,
            formatDay: true,
            width: "300",
            align: "left",
        },
        auditStatusCn: {
            label: "审批结果",
            visible: true,
            width: "auto",
            align: "left",
        },
    },
};